import { sentryLogger } from '@/adapters/logger/sentryLogger';
import { storage } from '@/adapters/storage/secureStorage';
import { createSettingsStore, type SettingsAdapters } from '@/stores/createSettingsStore';

const productionAdapters: SettingsAdapters = {
  secureStore: storage,
  logger: sentryLogger,
};

const useSettingsStore = createSettingsStore(productionAdapters);

export { useSettingsStore };
